import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { useProgrammes } from "@/hooks/useProgrammes";
import { ProgrammeCard } from "@/components/site/ProgrammeCard";
import { HeroSearch } from "@/components/home/HeroSearch";
import { Services } from "@/components/home/Services";
import { Process } from "@/components/home/Process";
import { waLink } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1785862703160-25734598ad7e?auto=format&fit=crop&w=2000&q=80";

const Hero = ({ programmes }) => (
  <section className="relative min-h-[90vh] flex items-end overflow-hidden bg-[#1A1716] grain" data-testid="hero-section">
    <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover opacity-80" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#1A1716]/90 via-[#1A1716]/55 to-transparent" />
    <div className="relative max-w-7xl mx-auto w-full px-5 lg:px-10 pb-16 pt-32">
      <p className="eyebrow rise">Promotion immobilière · Sénégal</p>
      <h1 className="font-display font-light text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02] mt-6 max-w-3xl rise" style={{ animationDelay: "120ms" }}>
        Des résidences pensées pour durer, bâties avec exigence.
      </h1>
      <p className="text-white/70 text-base md:text-lg mt-6 max-w-xl rise" style={{ animationDelay: "240ms" }}>
        Hélium Résidences conçoit, construit et commercialise des programmes immobiliers à Ngaparou, Nguérigne et au-delà.
      </p>
      <div className="flex flex-wrap gap-4 mt-10 rise" style={{ animationDelay: "360ms" }}>
        <Link to="/programmes" className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#C88A58] hover:bg-[#b57849] text-white rounded-full text-sm transition-colors duration-300" data-testid="hero-programmes-button">
          Découvrir nos programmes <ArrowRight className="h-4 w-4" />
        </Link>
        <a href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/30 hover:bg-white/10 text-white rounded-full text-sm transition-colors duration-300" data-testid="hero-whatsapp-button">
          <MessageCircle className="h-4 w-4" /> Écrire sur WhatsApp
        </a>
      </div>
      <HeroSearch programmes={programmes} />
    </div>
  </section>
);

export default function Home() {
  const { data: all } = useProgrammes();
  const featured = all.filter((p) => p.featured);
  return (
    <div data-testid="home-page">
      <Hero programmes={all} />
      <section className="max-w-7xl mx-auto px-5 lg:px-10 py-24 md:py-32" data-testid="featured-programmes-section">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="eyebrow">Nos programmes</p>
            <h2 className="font-display text-4xl lg:text-5xl mt-4 max-w-xl">Des adresses choisies, des projets maîtrisés</h2>
          </div>
          <Link to="/programmes" className="text-sm text-[#2F2A28] inline-flex items-center gap-2 hover:text-[#C88A58] transition-colors" data-testid="featured-see-all-link">
            Voir tous les programmes <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((p, i) => <ProgrammeCard key={p.id} p={p} index={i} />)}
        </div>
      </section>
      <Services />
      <Process />
      <section className="bg-[#1F3A2B] text-white relative grain" data-testid="cta-section">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-20 flex flex-col lg:flex-row lg:items-center justify-between gap-10">
          <h2 className="font-display text-4xl lg:text-5xl max-w-2xl">Un projet d'achat, de location ou de construction ? Parlons-en.</h2>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact" className="px-7 py-3.5 bg-[#C88A58] hover:bg-[#b57849] rounded-full text-sm transition-colors duration-300" data-testid="cta-contact-button">Nous contacter</Link>
            <a href={waLink()} target="_blank" rel="noreferrer" className="px-7 py-3.5 border border-white/30 hover:bg-white/10 rounded-full text-sm transition-colors duration-300" data-testid="cta-whatsapp-button">WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}
